import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email: email.trim() });
      if (data?.status === "already_subscribed") {
        toast.success("You're already subscribed — thank you!");
      } else {
        toast.success("Subscribed! Look out for our weekly investing insights.");
      }
      setEmail("");
    } catch (err) {
      toast.error("Please enter a valid email address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className="flex flex-col sm:flex-row gap-2"
      aria-label="Newsletter signup"
    >
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          aria-label="Email address"
          data-testid="newsletter-email-input"
          className="w-full pl-10 pr-3 py-3 rounded-full bg-black/60 border border-white/10 text-white text-sm placeholder:text-gray-500 focus:border-[#D4AF37]/60 focus:outline-none transition"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#D4AF37] text-black font-semibold text-sm hover:bg-[#FFD700] disabled:opacity-60 transition"
      >
        {loading ? "..." : (<>Subscribe <ArrowRight size={14} /></>)}
      </button>
    </form>
  );
}
